export default __webpack_public_path__ + "static/media/06WonWon60s.cdb54c2d.mp3";